import { render, staticRenderFns } from "./Purchase_details.vue?vue&type=template&id=2b0bf695&scoped=true&"
import script from "./Purchase_details.vue?vue&type=script&lang=js&"
export * from "./Purchase_details.vue?vue&type=script&lang=js&"
import style0 from "./Purchase_details.vue?vue&type=style&index=0&id=2b0bf695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bf695",
  null
  
)

export default component.exports